import { useEffect } from 'react'
import {
  useLocation,
  useNavigate,
  useParams,
  useRouteLoaderData,
} from 'react-router-dom'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'

import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import {
  useAlbumInvalidation,
  usePhotoStore,
} from '../../../store/PhotoContext'
import type { AlbumInfoLoaderData } from '../AlbumInfo/AlbumInfo.loaders'

import { AlbumContainer } from './Album.container'

const debug = Debug('jotta:photos:Album.route')

export const AlbumRoute = observer(function AlbumRoute({
  loaderId,
}: {
  loaderId: string
}) {
  const data = useRouteLoaderData(loaderId) as AlbumInfoLoaderData
  const { albumId = '', mediaId = '' } = useParams()
  const photoStore = usePhotoStore()
  const location = useLocation()
  const pathname = location.pathname
  const backLocation = pathname.slice(0, pathname.lastIndexOf('/'))

  const navigate = useNavigate()
  const redirectTo = data.redirectTo
  const store = photoStore.albumRoot.getAlbumInfoQueryStore(albumId)
  const album = store.album

  useAlbumInvalidation(store)

  useEffect(() => {
    if (redirectTo) {
      debug('Redirect to', redirectTo)

      navigate(redirectTo, {
        replace: true,
      })
    }
  }, [redirectTo, navigate])

  if (redirectTo || !album) {
    return <LoadingOverlay id="Album.route" open />
  }

  return (
    <AlbumContainer
      album={album}
      mediaId={mediaId}
      backLocation={backLocation}
    />
  )
})
